/**
 * Nsection Appendix Service
 * 附錄 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/nsection-appendix';

export interface AppendixItem {
  title: string;
  content: string;
}

export interface NsectionAppendixDetail {
  id: number;
  organization_id: number;
  proposal_id: number;
  appendices: AppendixItem[] | null;
  nsection_appendix_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NsectionAppendixUpdate {
  appendices?: AppendixItem[];
}

const nsectionAppendixService = {
  getByProposal: async (proposalId: number): Promise<NsectionAppendixDetail | null> => {
    const response = await axios.get(`${BASE_URL}/by-proposal/${proposalId}`);
    return response.data;
  },
  update: async (proposalId: number, data: NsectionAppendixUpdate): Promise<NsectionAppendixDetail> => {
    const response = await axios.put(`${BASE_URL}/${proposalId}`, data);
    return response.data;
  },
};

export default nsectionAppendixService;
